<template>
  <div class="entry">
    <div class="entry_banner">
      <img
        v-if="$store.state.wWidth > 768"
        src="../assets/index-banner.png"
        alt
      />
      <img v-else src="../assets/mobile/IndexBanner_Mobile@2x.png" alt />
      <div
        :class="`childPageTemp_title childPageTemp_title_${$i18n.locale}`"
        style="text-align: right"
      >
        <div v-if="$store.state.isMobile">
          {{ $t("message.online_service_mobile") }}
        </div>
        <div v-else>{{ $t("message.online_service") }}</div>
      </div>
    </div>
    <div class="entry_content">
      <EntryBtnGroup>
        <!-- 車輛服務 -->
        <div class="m-entry-title">
          <img src="@/assets/d-arrow-right.png" width="32px" />
          {{ $t("message.vehicle_service_title") }}
        </div>
        <EntryBtn
          localIcon="car.png"
          :label="$t('message.entries.home.one')"
          :locale="true"
          @click="btnClick('/entry', 'one')"
        ></EntryBtn>
        <EntryBtn
          localIcon="BusTaxi.png"
          :label="$t('message.entries.home.two')"
          :locale="true"
          @click="btnClick('/entryBus', 'two')"
        ></EntryBtn>
        <EntryBtn
          v-if="hasHzmbTruck"
          localIcon="hzmb-gh.png"
          :label="$t('message.entries.home.hzmbTruck')"
          :locale="true"
          @click="btnClick('/hzmb-truck', 'hzmb-gh')"
        ></EntryBtn>
        <EntryBtn
          localIcon="epay_ICRenewal.png"
          :label="$t('message.epay_ICRenewal')"
          :locale="true"
          @click="btnClick(getPathByEnv('epay_ICRenewal'), '', 'URL')"
        ></EntryBtn>
        <EntryBtn
          localIcon="epay_Cert_005.png"
          :label="$t('message.epay_Cert_005')"
          :locale="true"
          @click="btnClick(getPathByEnv('epay_Cert_005'), '', 'URL')"
        ></EntryBtn>
        <EntryBtn
          localIcon="DSAT9037.png"
          :label="$t('message.DSAT9037')"
          :locale="true"
          @click="btnClick(getPathByEnv('DSAT9037'), '', 'URL')"
        ></EntryBtn>

        <!-- 駕照服務 -->
        <div class="m-entry-title">
          <img src="@/assets/d-arrow-right.png" width="32px" />
          {{ $t("message.lic_service_title") }}
        </div>
        <EntryBtn
          v-if="hasSchool"
          localIcon="school.png"
          :label="$t('message.entries.home.five')"
          :locale="true"
          @click="btnClick('/entrySchool', 'five')"
        ></EntryBtn>
        <EntryBtn
          localIcon="epay_Cert_004.png"
          :label="$t('message.epay_Cert_004')"
          :locale="true"
          @click="btnClick(getPathByEnv('epay_Cert_004'), '', 'URL')"
        ></EntryBtn>
        <div class="m-entry-title">
          <img src="@/assets/d-arrow-right.png" width="32px" />
          {{ $t("message.other_service_title") }}
        </div>
        <!-- 其他服務 -->
        <EntryBtn
          v-if="hasTaxi"
          localIcon="Driver.png"
          :label="$t('message.entries.home.three')"
          :locale="true"
          @click="btnClick('/entryTaxi', 'three')"
        ></EntryBtn>
        <EntryBtn
          localIcon="DSAT0051.png"
          :label="$t('message.DSAT0051')"
          :locale="true"
          @click="btnClick(getPathByEnv('DSAT0051'), '', 'URL')"
        ></EntryBtn>
        <EntryBtn
          localIcon="DSAT0046.png"
          :label="$t('message.DSAT0046')"
          :locale="true"
          @click="btnClick(getPathByEnv('DSAT0046'), '', 'URL')"
        ></EntryBtn>
      </EntryBtnGroup>
    </div>
  </div>
</template>

<script>
import EntryBtn from "../components/EntryBtn";
import EntryBtnGroup from "../components/EntryBtnGroup";
import ServiceTypeConfigAPI from "../api/ServiceTypeConfigAPI";
export default {
  components: { EntryBtn, EntryBtnGroup },
  data() {
    return {
      commonEntries: {
        epay_ICRenewal: {
          uat: "https://epay.dsat.gov.mo/epayic/",
          production: "https://epay.dsat.gov.mo/epayic/",
        },
        epay_Cert_004: {
          uat: "https://epaydev.dsat.gov.mo/epay/licensedoc/chooseaction.aspx",
          production:
            "https://epay.dsat.gov.mo/EpayDLC/LicenseDoc/ChooseAction.aspx",
        },
        epay_Cert_005: {
          uat: "https://epaydev.dsat.gov.mo/EpayVC/VehicleCert/Default.aspx",
          production: "https://epay.dsat.gov.mo/EpayVC/VehicleCert/",
        },
        DSAT0051: {
          uat: "https://dsatpasuat.dsat.gov.mo/common/dsat_web/#/entry/DSAT0051",
          production:
            "https://app.dsat.gov.mo/common/dsat_web/#/entry/DSAT0051",
        },
        DSAT0046: {
          uat: "https://dsatpasuat.dsat.gov.mo/common/dsat_web/#/entry/DSAT0046",
          production:
            "https://app.dsat.gov.mo/common/dsat_web/#/entry/DSAT0046",
        },
        DSAT9037: {
          uat: "https://dsatpasuat.dsat.gov.mo/common/dsat_web/#/entry/DSAT9037",
          production:
            "https://app.dsat.gov.mo/common/dsat_web/#/entry/DSAT9037",
        },
      },

      hasHzmbTruck: false,
      hasSchool: false,
      hasTaxi: false,
    };
  },
  computed: {
    env() {
      const env = process.env.VUE_APP_ENV;
      return ["uat", "production"].includes(env) ? env : "uat";
    },
    getPathByEnv() {
      return (entry) => {
        return this.commonEntries[entry][this.env];
      };
    },
  },
  methods: {
    btnClick(path, lanCode, type) {
      if (type === "URL") {
        window.location.href = path;
      } else {
        localStorage.setItem("childTempTitle", lanCode);
        this.$router.push(path);
      }
    },
  },
  async created() {
    this.$store.commit("changeServiceType", null);

    // 根據是否有服務來判斷顯示入口
    const hzmb = await ServiceTypeConfigAPI.get("HZMB");
    this.hasHzmbTruck = hzmb.find((e) =>
      ["HZMB_G_FIRST", "HZMB_G_RENEW", "HZMB_G_CANCEL"].includes(e.serviceType)
    );

    const school = await ServiceTypeConfigAPI.get("SCHOOL");
    this.hasSchool = school && school.length > 0;

    const taxi = await ServiceTypeConfigAPI.get("TAXI");
    this.hasTaxi = taxi && taxi.length > 0;
  },
};
</script>

<style lang="scss" scoped>
.entry {
  margin: auto;
}
.entry_banner {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.entry_banner img {
  width: 100%;
  // max-width: 1440px;
  display: block;
  margin: auto;
}
.childPageTemp_title {
  // justify-content: flex-end;
}
.entry_content {
  // max-width: 1440px;
  margin: auto;
  min-height: 450px;
  padding-top: 56px;
  padding-bottom: 45px;
  background: #f9f9f9;
}
.m-entry-title {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 32px;
  font-weight: bold;
  margin-left: 5%;
  margin-bottom: 24px;
  padding-bottom: 8px;
  img {
    margin-right: 12px;
  }
}

@media screen and (max-width: 767px) {
  .entry_content {
    padding-top: 24px;
  }
}
</style>
